import { render, staticRenderFns } from "./userinfoModel.vue?vue&type=template&id=401ccaa6&scoped=true"
import script from "./userinfoModel.vue?vue&type=script&lang=js"
export * from "./userinfoModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ccaa6",
  null
  
)

export default component.exports